import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=2a73ff02&scoped=true"
import script from "./OnBoarding.vue?vue&type=script&lang=js"
export * from "./OnBoarding.vue?vue&type=script&lang=js"
import style0 from "./OnBoarding.vue?vue&type=style&index=0&id=2a73ff02&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a73ff02",
  null
  
)

export default component.exports